module.exports = __webpack_public_path__ + "img/right-arrow.e82a4dbe.png";